export class ListIngestionPipelinesFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "IngestionPipelineStatusFilters",
            "format": ""
        },
        {
            "name": "catalogId",
            "baseName": "catalogId",
            "type": "IdFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListIngestionPipelinesFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
